import React from 'react';
import { Modal, XFilledIcon, Grid, Button } from "react-unity";

export interface TrashcanModalProps {
	onRemove: () => any;
    onClose: () => any;
}

const TrashcanModal = (trashcanModalProps: TrashcanModalProps) => {
    return (
            <Modal show={true}>
				<Modal.Window>
					<Modal.Window.Header>
						<Modal.Window.Header.Title>Remove Rule?</Modal.Window.Header.Title>
						<Modal.Window.Header.CloseButton onClick={trashcanModalProps.onClose}>
							<XFilledIcon size='small' />
						</Modal.Window.Header.CloseButton>
					</Modal.Window.Header>					
					<Modal.Window.Footer>
						<Grid variant="2-up">
                            <Grid.Item>
								<Button variant="primary" onClick={trashcanModalProps.onClose}>
									Cancel
								</Button>
							</Grid.Item>
							<Grid.Item>
								<Button variant="secondary" color="accent" onClick={trashcanModalProps.onRemove}>
									Remove from request
								</Button>
							</Grid.Item>
						</Grid>
					</Modal.Window.Footer>
				</Modal.Window>
			</Modal>
    );
}

export default TrashcanModal;